import { render } from "./LoginForm.vue?vue&type=template&id=4ed5c820"
import script from "./LoginForm.js?vue&type=script&lang=yaml"
export * from "./LoginForm.js?vue&type=script&lang=yaml"
/* custom blocks */
import block0 from "./LoginForm.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FLogin%2FLoginForm%2FLoginForm.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__